import html2pdf from 'html2pdf.js';
import * as Handlebars from "handlebars";
import {getUrl} from "aws-amplify/storage";


export function htmlToPDF(dataSource, meta, template, parameters) {

    // HELPERS

    // extract countries from their 2 digit code
    Handlebars.registerHelper('countryNameFromCode', function (code) {
        const countryMap = meta.countryCodes["en-gb"]
        return countryMap[code] || 'Unknown';
    });

    // format date strings
    Handlebars.registerHelper('formatDate', function (dateString) {
        if (!dateString) return 'N/A'; // Handle empty cases

        const options = {day: 'numeric', month: 'long', year: 'numeric'}; // Full month name
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', options); // 'en-GB' for British English formatting
    });

    // get the signed URL for a specific file
    Handlebars.registerHelper('getFileUrl', function (dataSource, dataKey) {

        // Check if dataSource is valid
        if (!Array.isArray(dataSource)) {
            console.warn(`Invalid dataSource for dataKey: ${dataKey}. Expected an array.`);
            return new Handlebars.SafeString(`<span>No files available</span>`);
        }

        // Find the file in the dataSource array that matches the dataKey
        const myFile = dataSource.find(file => file.dataKey === dataKey);
console.log(myFile)
        if (myFile) {
            // Return a placeholder link
            return new Handlebars.SafeString(`<span class="file-link" file-key="${myFile.fileKey}" data-key="${myFile.dataKey}">${myFile.name || 'Download File'}</span>`);
        }

        return new Handlebars.SafeString(`<span>No file found for ${dataKey}</span>`);
    });

    (async () => {
        try {
            console.log("Processing single submission to PDF...");
            console.log("Template", template);

            let applicantSurname = "";

            // Generate HTML content from the provided template for the single submission
            // const htmlContent = generateHTMLFromTemplate(template, submission);
            const compiledTemplate = Handlebars.compile(template);
            const htmlContent = compiledTemplate(dataSource);

            // Create a container element to store the generated HTML
            const htmlContainer = document.createElement('div');
            htmlContainer.innerHTML = htmlContent;

            // === constants derived from your options ===
            const mmToPx = 96 / 25.4; // px per mm at 96dpi
            const pageWidthMm = 210;       // A4
            const pageHeightMm = 297;      // A4
            const margins = { top: 20, right: 30, bottom: 10, left: 30 }; // must match options.margin

            // content width in px (prevents right-edge clipping)
            const contentWidthPx = (pageWidthMm - margins.left - margins.right) * mmToPx;
            // usable page height in px (where html2pdf will slice)
            const usableHeightPx = (pageHeightMm - margins.top - margins.bottom) * mmToPx;

            // --- layout stability ---
            htmlContainer.style.width = `${contentWidthPx}px`; // lock to content width
            htmlContainer.style.lineHeight = '24px';           // integer px line-height
            htmlContainer.style.paddingBottom = '16px';
            htmlContainer.style.boxSizing = 'border-box';
            document.body.appendChild(htmlContainer);          // mount before measuring

            // align page-cut grid to the baseline so slices fall between lines
            const lineHeightPx = parseFloat(getComputedStyle(htmlContainer).lineHeight) || 24;

            // >>> FIX 1: align in *scaled* space (respect html2canvas.scale)
            const scale = 2; // must match options.html2canvas.scale below
            const usableScaled = usableHeightPx * scale;
            const lineScaled   = lineHeightPx * scale;
            const remScaled = usableScaled % lineScaled;
            const padTopPx = remScaled === 0 ? 0 : (lineScaled - remScaled) / scale; // back to CSS px
            htmlContainer.style.paddingTop = `${padTopPx}px`;

            // === keep heading/label with first block (wrapper + pagebreak.avoid) ===
            const isHeadingLike = (el) => {
                if (!el) return false;
                const tag = el.tagName;
                if (/^H[1-6]$/.test(tag)) return true;
                if (tag === 'P' || tag === 'DIV') {
                    const cs = window.getComputedStyle(el);
                    const fw = parseInt(cs.fontWeight, 10) || 400;
                    const txt = (el.textContent || '').trim();
                    if (fw >= 600 && txt.length <= 140) return true;           // short bold label
                    if (/[:：]\s*$/.test(txt) && txt.length <= 140) return true; // ends with :
                }
                return false;
            };

            const nextVisibleSibling = (el) => {
                let n = el.nextSibling;
                while (n) {
                    if (n.nodeType === 1) {
                        const e = /** @type {HTMLElement} */(n);
                        const ds = window.getComputedStyle(e).display;
                        if (ds !== 'none' && e.offsetHeight > 0) return e;
                    }
                    n = n.nextSibling;
                }
                return null;
            };

            Array.from(htmlContainer.querySelectorAll('h1,h2,h3,h4,h5,h6,p,div')).forEach(h => {
                if (!isHeadingLike(h)) return;
                if (h.parentElement && h.parentElement.classList.contains('no-split')) return;
                const next = nextVisibleSibling(h);
                if (!next) return;
                const wrap = document.createElement('div');
                wrap.className = 'no-split';
                h.parentNode.insertBefore(wrap, h);
                wrap.appendChild(h);
                wrap.appendChild(next);
            });

            // Generate signed URLs for all file links in the HTML
            const fileLinks = htmlContainer.querySelectorAll('.file-link');
            for (const link of fileLinks) {
                const fileKey = link.getAttribute('file-key');
                const dataKey = link.getAttribute('data-key');
                console.log(dataKey)
                // const fileKeyNoExtension = fileKey.split('.')[0]; // Assuming the dataKey is the name before the first dot

                // Extract the file extension for the filename
                const fileExtension = fileKey.split('.').pop();
                const applicationNumber = dataSource.meta.trackingNumber;

                // Correctly extract the applicant's surname
                applicantSurname = dataSource.data.submission.meta.owner?.familyName || '';

                // Construct the filename
                const formattedFileName = `Application_${applicationNumber}_${applicantSurname}_${dataKey}.${fileExtension}`;

                try {
                    const signedUrlObj = await getUrl({key: fileKey});
                    const signedUrl = signedUrlObj.url || signedUrlObj.href; // Access the correct property here

                    // Update the link to open in a new tab with the correct filename
                    link.innerHTML = `<a href="${signedUrl}" target="_blank" download="${formattedFileName}">Click to download</a>`;

                } catch (error) {
                    console.error(`Error generating signed URL for ${fileKey}:`, error);
                    link.innerHTML = 'Error generating link'; // Fallback text
                }
            }

            // Continue with PDF generation
            const filename = parameters?.filename + "_" + (dataSource.meta?.trackingNumber ? dataSource.meta.trackingNumber : dataSource.id) + "_" + applicantSurname;

            const options = {
                margin: [margins.top, margins.left, margins.bottom, margins.right], //top, left, buttom, right,
                filename: filename + ".pdf", // Append ".pdf" extension
                image: {type: 'jpeg', quality: 0.98},
                html2canvas: {
                    scale,                 // keep in sync with 'scale' used above
                    useCORS: true,
                    letterRendering: true,
                    scrollY: 0,
                    windowWidth: contentWidthPx // render at the same width as content area
                },
                jsPDF: {unit: 'mm', format: 'a4', orientation: 'portrait'},
                pagebreak: {
                    mode: ['css','legacy'],
                    // >>> FIX 2: also avoid breaks inside paragraphs to protect one-line label+value
                    avoid: ['.no-split','p']
                }
            };

            // Generate the PDF from the container's HTML
            await html2pdf().from(htmlContainer).set(options).save();

            // cleanup
            document.body.removeChild(htmlContainer);

        } catch (error) {
            console.error("Error processing submission data:", error);
        }
    })();

    /*

        // 2. Compile the Handlebars template with dataSource
        console.log(template, typeof template)
        const compiledTemplate = Handlebars.compile(template);
        const content = compiledTemplate(dataSource);

        // 3. Convert the compiled HTML content to a PDF and download it
        const options = {
            margin: 1,
            filename: parameters?.filename  + ".pdf" || 'document.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
        };

        html2pdf()
            .from(content)
            .set(options)
            .save();*/
}
